module.exports = "<div class=\"fleet-reports-select-placeholder\">\n\t<img src=\"../assets/reports-fleet-select.PNG\" style=\"width:230px; height: auto;\" alt=\"\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fleet-reports/fleet-reports.html
// module id = ./src/app/components/fleet-reports/fleet-reports.html
// module chunks = main